import React from "react";

import { Col, Container, Image, Row } from "react-bootstrap";

import BannerComponent from "@/components/Banner.component";

import DocumentComponent from "../components/Document.component";
import ScheduleComponent from "../components/Schedule.component";
import i18n from "../i18n";

const images = [
  "/images/multi-storey-buildings/PakVille01.png",
  "/images/multi-storey-buildings/PakVille02.png",
  "/images/multi-storey-buildings/PakVille03.png",
];

const MultiStoreyBuildings = () => {
  const { t } = i18n;

  return (
    <React.Fragment>
      <DocumentComponent title={t("Multi-Storey Buildings")} />
      <BannerComponent description="" title={t("Multi-Storey Buildings")} />

      <Container>
        <Row>
          <Col>
            <p>
              {t(
                "PakVert™ panels offer a modern, efficient, and high-performance approach to constructing low- to high-rise buildings. Designed as a comprehensive all-in-one system, our panels replace multiple traditional trades, dramatically reducing on-site labour, installation time, and construction waste.",
              )}
            </p>

            <p>
              {t(
                "With superior insulation performance, exceptional durability, and consistent factory-controlled quality, PakVert™ panels deliver a faster, cleaner, and more predictable building process.",
              )}
            </p>

            <p>
              {t(
                "PakVert™ panels can be used for both exterior and interior wall systems, enabling streamlined design, simplified coordination, and a highly energy-efficient building envelope for multi-storey projects of any scale.",
              )}
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          {images.map((image, index) => (
            <Col key={index} xs={4}>
              <Image
                rounded
                alt={`PakVille-${index}`}
                className="mw-100 mb-2"
                src={image}
              />
            </Col>
          ))}
        </Row>
      </Container>

      <ScheduleComponent />

      <br />
      <br />
      <br />
    </React.Fragment>
  );
};

export default MultiStoreyBuildings;
